import { createRouter } from '@tanstack/react-router';
import type { QueryClient } from '@tanstack/react-query';

import { RouteError } from '@/components/common/route-error';
import { SplashScreen } from '@/components/common/splash-screen';
import { routeTree } from '@/routeTree.gen';

export type RouterContext = { queryClient: QueryClient };

export function createAppRouter(queryClient: QueryClient) {
  return createRouter({
    routeTree,
    context: { queryClient },
    defaultPreload: 'intent',
    defaultPendingComponent: SplashScreen,
    // An online-only screen opened offline before its code was ever cached.
    defaultErrorComponent: RouteError,
    defaultPendingMs: 300,
    scrollRestoration: true,
  });
}

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof createAppRouter>;
  }
}
